import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import * as Sentry from '@sentry/react'
import { clearEntityTags } from '@/lib/sentry/entity-tags'
import { AuthActions, AuthState } from './types'

const initialState: AuthState = {
  userId: null,
  organizationId: null,
  role: null,
}

export const useAuthStore = create<AuthState & AuthActions>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,

        setAuth: (userId, orgId, role) => {
          set({
            userId,
            organizationId: orgId,
            role,
          })
          // Attaches user context to every subsequent Sentry event (error
          // reports show WHO hit it, not just an anonymous stack trace).
          Sentry.setUser({ id: userId, organizationId: orgId, role })
          // Custom setUser fields are stored but not first-class filterable —
          // tags are. Single vocabulary with the API (organization + role).
          Sentry.setTag('organization', orgId)
          Sentry.setTag('role', role)
        },

        reset: () => {
          set(initialState)
          Sentry.setUser(null)
          // Clear identity + entity tags so a later anonymous error can't
          // inherit the signed-out user's org/role or a previously-viewed
          // entity id (cross-tenant leak on the global browser scope).
          Sentry.setTag('organization', undefined)
          Sentry.setTag('role', undefined)
          clearEntityTags()
        },
      }),
      {
        name: 'auth-storage',
        partialize: (state) => ({
          userId: state.userId,
          organizationId: state.organizationId,
          role: state.role,
        }),
      }
    ),
    { name: 'AuthStore' }
  )
)
